define(["mw-log/Log"], function (Log) {
  "use strict";

  var _exports = {};
  // Copyright 2022-2023 The MathWorks, Inc.

  /**
   * Defines the common interface implemented by the MatlabSender and DirectSender sub classes.
   * @private
   */
  class Sender {
    start(properties) {}
    stop() {}
    sendEvent(eventType, event) {
      Log.warn('Sender.sendEvent not overridden');
    }
  }
  _exports.default = Sender;
  return _exports.default;
});
//# sourceMappingURL=Sender.js.map
